import { render, staticRenderFns } from "./BoardFeature.vue?vue&type=template&id=5ba84517&scoped=true&lang=pug&"
import script from "./BoardFeature.vue?vue&type=script&lang=js&"
export * from "./BoardFeature.vue?vue&type=script&lang=js&"
import style0 from "./BoardFeature.vue?vue&type=style&index=0&id=5ba84517&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba84517",
  null
  
)

export default component.exports